
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/identity",
      function () {
        return require("private-next-pages/docs/identity/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/identity"])
      });
    }
  